/**
 * Carillon « nouvelle commande » du backoffice, généré par Web Audio (pas de
 * fichier à charger). Le navigateur n'autorise le son qu'après une première
 * interaction avec la page : sinon l'appel est simplement ignoré.
 */
let context = null

export function playNewOrderSound() {
    try {
        const AudioContext = window.AudioContext || window.webkitAudioContext
        if (!AudioContext) return
        context ??= new AudioContext()
        if (context.state === 'suspended') context.resume()

        const start = context.currentTime
        // Deux notes montantes (mi puis la), répétées une fois
        ;[[659.25, 0], [880, 0.18], [659.25, 0.5], [880, 0.68]].forEach(([frequency, offset]) => {
            const oscillator = context.createOscillator()
            const gain = context.createGain()
            oscillator.type = 'sine'
            oscillator.frequency.value = frequency
            gain.gain.setValueAtTime(0.0001, start + offset)
            gain.gain.exponentialRampToValueAtTime(0.35, start + offset + 0.02)
            gain.gain.exponentialRampToValueAtTime(0.0001, start + offset + 0.3)
            oscillator.connect(gain).connect(context.destination)
            oscillator.start(start + offset)
            oscillator.stop(start + offset + 0.32)
        })
    } catch (e) {
        // son indisponible : la notification visuelle suffit
    }
}
